<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">Edit Event Images</h2>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <div class="row">
      <h3>Header Image</h3>
      <p class="text-muted">Upload a new header image for your event (recommended size: 1920x300)</p>
    </div>

    @if (event.header_url) {
      <div class="row spacing-15">
        <div class="col-12">
          <label class="form-label">Current Header Image</label>
          <div class="mb-3">
            <img [src]="event.header_url" alt="Current header" style="max-width: 100%; max-height: 200px; object-fit: cover; border-radius: 8px;">
          </div>
        </div>
      </div>
    }

    <div class="row spacing-15">
      <div class="col-12">
        <label class="form-label">New Header Image</label>
        <app-fileorini
          [accept]="'image/*'"
          (filesChanged)="headerFile = $event[0]"
        />
      </div>
    </div>

    <div class="row spacing-15">
      <div class="col-12 d-flex justify-content-end">
        <app-button
          [variant]="'primary'"
          [label]="'Upload Header'"
          [iconClass]="'fa fa-upload'"
          [disabled]="!headerFile"
          (clicked)="onSaveHeader()"
        />
      </div>
    </div>

    <div class="separator my-6"></div>

    <div class="row">
      <h3>Event Image</h3>
      <p class="text-muted">Upload a new profile image for your event (recommended size: 400x400)</p>
    </div>

    @if (event.image_url) {
      <div class="row spacing-15">
        <div class="col-12">
          <label class="form-label">Current Event Image</label>
          <div class="mb-3">
            <img [src]="event.image_url" alt="Current event image" style="max-width: 300px; max-height: 300px; object-fit: cover; border-radius: 8px;">
          </div>
        </div>
      </div>
    }

    <div class="row spacing-15">
      <div class="col-12">
        <label class="form-label">New Event Image</label>
        <app-fileorini
          [accept]="'image/*'"
          (filesChanged)="imageFile = $event[0]"
        />
      </div>
    </div>

    <div class="row spacing-15">
      <div class="col-12 d-flex justify-content-end">
        <app-button
          [variant]="'primary'"
          [label]="'Upload Image'"
          [iconClass]="'fa fa-upload'"
          [disabled]="!imageFile"
          (clicked)="onSaveImage()"
        />
      </div>
    </div>
  </div>
</div>
